export {default as Hris} from './Home';
export {default as HrLogin} from './Login';
export {default as AttnReport} from './AttnReport';
export {default as Atten} from './Atten';
export {default as Leave} from './Leave';
export {default as AttenRegister} from './AttenRegister';
export {default as EmployeeInfo} from './EmployeeInfo';
export {default as EmployeeEdit} from './EmployeeEdit';
export {default as Generate} from './Generate';
export {default as AddEmployee} from './AddEmployee';
export {default as IctEquipment} from './IctEquipment';
export {default as AddEquipment} from './AddEquipment';
export {default as AttendanceAdjustment} from './AttendanceAdjustment';
export {default as DocrInfo} from './DocrInfo';
export {default as UploadExcel} from './UploadExcel';
export {default as TypeTest} from './TypingTest';
export {default as IpFinder} from './IpFinder';
export {default as HRDashboard} from './Dashboard';
export {default as LateAttendance} from './LateAttendance';
export {default as UserSettingsHRIS} from '../dashboard/UserSettings';